<template>
	<div class="parent-subject-uploads">
		<div class="ui button denied-subjects-button" style="margin-bottom: 1em" @click="viewDeniedSubjects" v-if="deniedSubjectAlbum && !viewingDenied">View Denied Subjects</div>
		<div class="ui button approved-subjects-button" style="margin-bottom: 1em" @click="viewApprovedSubjects" v-if="viewingDenied">View Unapproved Subjects</div>
		<custom-pager empty-message="No pending uploads" :data="computedIncomingSubjects" :loading="loading">
			<template slot-scope="slotProps">
				<div class="ui stackable doubling cards four">
					<parent-subject-upload-card v-for="subject in slotProps.visible" :key="subject.id" :subject="subject" :project="project" @removePending="removePending" :denied-subject-album="deniedSubjectAlbum" :viewing-denied="viewingDenied" />
				</div>
			</template>
		</custom-pager>
	</div>
</template>

<script>
import ParentSubjectUploadCard from './ParentSubjectUploadCard.vue';
import CustomPager from '../../../components/CustomPager.vue';

export default {
	props: {
		incomingSubjects: {
			default: function() {
				return [];
			}
		},
		project: null
	},
	data: function() {
		return {
			loading: false,
			deniedSubjectAlbum: null,
			sortedSubjects: false,
			viewingDenied: false,
			deniedSubjects: null,
			mounted: false
		};
	},
	watch: {
		project: function(value) {
			this.loadSubjects();
		},
		incomingSubjects: function(val) {
			if(val && !this.sortedSubjects) {
				this.sortedSubjects = true;
				val.forEach(function(subject) {
					subject.properties = {};

					subject.tags.forEach(function(tag) {
						var search = ': ';
						var index = tag.indexOf(search);
						if(index !== -1 && tag.indexOf('PROP-') !== -1) {
							var name = tag.substr(0, index).replace('PROP-', '');
							var value = tag.substr(index + search.length);
							subject.properties[name] = value;
						}
					});
				});

				val.sort(function(a, b) {
					return $.SubjectManagement.compareSubjects(a.properties, b.properties);
				});
			}
		}
	},
	computed: {
		computedIncomingSubjects: function() {
			if(this.viewingDenied) {
				return this.deniedSubjects || [];
			} else {
				return this.incomingSubjects;
			}
		}
	},
	methods: {
		removePending: function(subject) {
			if(this.viewingDenied) {
				this.deniedSubjects.removeMatch(subject, 'id');
			} else {
				this.incomingSubjects.removeMatch(subject, 'id');
				window.loadIncomingSubjectPhotosDone(this.incomingSubjects);
			}
		},
		loadSubjects: function() {
			if(!this.project || !this.mounted) {
				return;
			}

			var me = this;
			this.loading = true;
			var chain = new $.ExecutionChain(function() {
				me.loading = false;
			});

			if(!this.project.subjects) {
				$.loadSubjects({
					plicProjectId: this.project.plicProjectId,
					populateWithTemplate: true,
					onComplete: function(subjects, projectTemplate) {
						me.project.subjects = subjects;
						me.project.template = projectTemplate;
					},
					onError: function() {
						$.Alert('Error', 'Failed to load subjects');
					}
				});
			}

			if(!this.project.subjectAlbumId) {
				chain.add($.getPlicAPI({
					method: 'albums',
					params: {
						parent_resource_type: 'project',
						parent_resource_id: this.project.plicProjectId,
						tag: 'Subject Photos'
					},
					type: 'GET',
					success: function(data) {
						var albums = data.albums;

						if(albums.length) {
							var albumId = albums[0].id;
							me.project.subjectAlbumId = albumId;
						} else {
							chain.add($.plicAPI({
								method: 'albums',
								params: {
									album: {
										name: 'Subject Photos',
										tags: [
											'Subject Photos'
										]
									},
									parent_resource_type: 'project',
									parent_resource_id: me.project.plicProjectId
								},
								success: function(data) {
									var albumId = data.album.id;
									me.project.subjectAlbumId = albumId;
								}
							}));
						}
					},
					error: function() {
						$.Alert('Error', 'Failed to load subject album');
					}
				}));
			}

			if(!this.deniedSubjectAlbum) {
				chain.add($.getPlicAPI({
					method: 'albums',
					params: {
						parent_resource_type: 'project',
						parent_resource_id: this.project.plicProjectId,
						tag: 'Guest Subjects - Denied'
					},
					type: 'GET',
					success: function(data) {
						var albums = data.albums;

						if(albums.length) {
							me.deniedSubjectAlbum = albums[0];
						} else {
							chain.add($.getPlicAPI({
								method: 'albums',
								params: {
									album: {
										name: 'Guest Subjects - Denied',
										tags: [
											'Guest Subjects - Denied'
										]
									},
									parent_resource_type: 'project',
									parent_resource_id: me.project.plicProjectId
								},
								success: function(data) {
									me.deniedSubjectAlbum = data;
								}
							}));
						}
					},
					error: function() {
						$.Alert('Error', 'Failed to load denied subject album');
					}
				}));
			}

			chain.done();
		},
		viewDeniedSubjects: function() {
			this.viewingDenied = true;
			this.loading = true;

			var me = this;
			$.loadAlbum({
				albumId: this.deniedSubjectAlbum.id,
				success: function(photos) {
					me.deniedSubjects = photos;
					me.loading = false;
				}
			});
		},
		viewApprovedSubjects: function() {
			this.viewingDenied = false;
		}
	},
	mounted: function() {
		this.loadSubjects();
		this.mounted = true;
	},
	components: {
		ParentSubjectUploadCard,
		CustomPager
	}
};
</script>

<style>
.parent-subject-uploads  .ui.card.subjectCard > .content > .header {
	font-size: 1.125em;
	white-space: nowrap;
}

.parent-subject-uploads .ui.card.subjectCard .header > .subjectAvatar {
    width: 4em;
	height: 5em;
	margin-right: 0.25em;

	overflow: hidden;
	border-radius: 50%;

	transform: translateY(0);
}
.parent-subject-uploads .ui.card.subjectCard .header > .subjectAvatar > img {
	height: 100%;
	width: 100%;
	position: relative;

	max-width: initial !important;
}
.parent-subject-uploads .ui.card.subjectCard .header > .content {
	white-space: initial;
	/* 100% - 2.5 for image, 2em for padding for parent content */
	width: calc(100% - 4.25em);
	display: inline-block;
	vertical-align: middle;
}
</style>